import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const Loading = ({ position = "absolute", size = 100 }) => {
  return (
    <Box
      sx={{
        display: "flex",
        left: "50%",
        top: "50%",
        marginLeft: "-50px",
        position,
        marginTop: "-50px",
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};

export default Loading;
